"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject, _templateObject2, _templateObject3;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  transform: translateY(-8px);\n"])));

var StyledButton = _styledComponents.default.button(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  padding: 0;\n  margin-left: 1rem;\n  height: 56px;\n\n  ", ";\n"])), function (p) {
  return p.isInactive && "opacity: 0.25;";
});

var StyledFlag = _styledComponents.default.img(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  height: 40px;\n"])));

var Signupvalue = function Signupvalue(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange;
  return /*#__PURE__*/_react.default.createElement(StyledWrapper, null, /*#__PURE__*/_react.default.createElement(StyledButton, {
    isInactive: value !== "dutch",
    disabled: value === "dutch",
    onClick: function onClick() {
      return onChange("dutch");
    }
  }, /*#__PURE__*/_react.default.createElement(StyledFlag, {
    src: "https://cdn.jsdelivr.net/gh/low6dev/toto-assets@master/flags/Netherlands.png"
  })), /*#__PURE__*/_react.default.createElement(StyledButton, {
    isInactive: value !== "en",
    disabled: value === "en",
    onClick: function onClick() {
      return onChange("en");
    }
  }, /*#__PURE__*/_react.default.createElement(StyledFlag, {
    src: "https://cdn.jsdelivr.net/gh/low6dev/toto-assets@master/flags/United-Kingdom.png"
  })));
};

var _default = Signupvalue;
exports.default = _default;